import { render } from "./TrainerReport.vue?vue&type=template&id=61632652&ts=true"
import script from "./TrainerReport.vue?vue&type=script&lang=ts"
export * from "./TrainerReport.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__